import { useEffect, useState } from "react";
import { useI18n } from "../i18n";
import { loadMyPayslips, loadPayslip, type MyPayslip } from "../data";
import { money, printPayslip } from "../lib/payslip";
import type { Workspace } from "../types";

/** Self-service: my payslips from approved payroll runs, ready to print or save as PDF. */
export function MyPayslips({ ws }: { ws: Workspace }) {
  const { t, lang } = useI18n();
  const [rows, setRows] = useState<MyPayslip[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => { loadMyPayslips(ws.membership.company_id).then(setRows).catch((e) => setError(e.message)); }, [ws.membership.company_id]);
  const month = (p: string) => new Date(`${p}T00:00:00`).toLocaleDateString(lang === "ar" ? "ar-EG" : "en-GB", { month: "long", year: "numeric" });

  async function open(r: MyPayslip) {
    const w = window.open("", "_blank");
    try {
      const p = await loadPayslip(r.payslip_id);
      printPayslip(p, { company: ws.membership.company.name, companyAr: ws.membership.company.name_ar ?? "", period: r.period, payDate: r.pay_date }, w);
    } catch (e) { w?.close(); setError(e instanceof Error ? e.message : t("errorGeneric")); }
  }

  return (
    <div className="page">
      {error && <p className="alert danger" role="alert">{error}</p>}
      <section className="card">
        <h2>{t("navMyPayslips")}</h2>
        {rows === null ? <p className="muted">{t("loading")}</p> : rows.length === 0 ? <p className="muted">{t("payNoMyPayslips")}</p> : (
          <ul className="req-list">
            {rows.map((r) => (
              <li key={r.payslip_id}>
                <span><strong>{month(r.period)}</strong> · {t("payNet")} <span className="mono">{money(r.net)}</span>
                  <span className="muted small-note"> · {t("payGross")} {money(r.gross)}</span></span>
                <button type="button" className="btn secondary small" onClick={() => open(r)}>{t("payPayslip")}</button>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
